import type { Translation } from '../i18n-types';

const fa: Translation = {
  userGuide: 'راهنمای کاربر',
  privacyPolicy: 'سیاست حریم خصوصی',
  termsConditions: 'شرایط و ضوابط',
  support: 'پشتیبانی',
  abandoned: 'رها شده',
  completed: 'تکمیل شده',
  cancelled: 'لغو شده',
  ended: 'پایان یافته',
  actionComments: 'نظرات اقدام',
  actionItem: 'آیتم اقدام',
  actionItemPlaceholder: 'آیتم اقدام...',
  actionItems: 'آیتم‌های اقدام',
  actionPhaseDescription: 'آیتم‌های اقدام اضافه کنید، دیگر نمی‌توانید نظرات را گروه‌بندی یا رأی‌گیری کنید',
  actions: 'اقدامات',
  activate: 'فعال‌سازی',
  active: 'فعال',
  activeRetros: 'رتروهای فعال',
  activeRetroUsers: 'کاربران رترو فعال',
  activeStoryboards: 'استوری‌بوردهای فعال',
  activeStoryboardUsers: 'کاربران استوری‌بورد فعال',
  addComment: 'افزودن نظر',
  addPersona: 'افزودن شخصیت',
  admin: 'مدیر',
  adminCleanOldRetros: 'پاک‌سازی رتروهای قدیمی‌تر از {daysOld} روز',
  adminCleanOldStoryboards: 'پاک‌سازی استوری‌بوردهای قدیمی‌تر از {daysOld} روز',
  adminPageAdmin: 'مدیریت',
  adminPageAlerts: 'هشدارها',
  adminPageApi: 'کلیدهای API',
  adminPageOrganizations: 'سازمان‌ها',
  adminPageTeams: 'تیم‌ها',
  adminPageUsers: 'کاربران',
  adminPageSubscriptions: 'اشتراک‌ها',
  deleteSubscriptionConfirmation: 'آیا مطمئن هستید که می‌خواهید این اشتراک را حذف کنید؟',
  deleteSubscription: 'حذف اشتراک',
  alertAllowDismiss: 'اجازه رد کردن',
  alertContent: 'محتوای هشدار',
  alertContentPlaceholder: 'محتوای هشدار را وارد کنید',
  alertCreate: 'ایجاد هشدار',
  alertDelete: 'حذف هشدار',
  alertDeleteConfirmation: 'آیا مطمئن هستید که می‌خواهید این هشدار را حذف کنید؟',
  alertNamePlaceholder: 'نام هشدار را وارد کنید',
  alertRegisteredOnly: 'فقط ثبت‌نام شده‌ها',
  alerts: 'هشدارها',
  alertSave: 'ذخیره هشدار',
  alertTypePlaceholder: 'نوع هشدار را انتخاب کنید',
  allVotesIn: 'همه رأی‌ها وارد شد',
  apiDocumentation: 'مستندات API',
  apikeyCopyFailure: 'کپی کلید API در کلیپ‌بورد ناموفق بود',
  apikeyCopySuccess: 'کلید API در کلیپ‌بورد کپی شد',
  apiKeys: 'کلیدهای API',
  applicationStatsError: 'خطا در دریافت آمار اپلیکیشن',
  appName: 'تاندردوم',
  appPreviewAlt: 'پیش‌نمایش تاندردوم، تجربه رابط کاربری چابک پلنینگ پوکر',
  appSubtitle: 'اپلیکیشن متن‌باز چابک پلنینگ پوکر',
  appVersion: 'نسخه {version}',
  associateTeam: 'مرتبط کردن تیم',
  authError: 'خطا در تلاش برای احراز هویت کاربر',
  autoFinishVoting: 'خودکار پایان دادن رأی‌گیری',
  avatarAltText: 'آواتار جایگزین',
  back: 'بازگشت',
  battleAbandon: 'رها کردن بازی',
  battleCreate: 'ایجاد بازی',
  battleDelete: 'حذف بازی',
  battleEdit: 'ویرایش بازی',
  battleEditPointsDisabled: 'رأی‌گیری فعال است، نمی‌توان امتیازهای مجاز را تغییر داد.',
  battleJoin: 'پیوستن به بازی',
  battleName: 'نام بازی',
  battleRemoveError: 'خطا در تلاش برای حذف بازی.',
  battleRemoveSuccess: 'بازی با موفقیت حذف شد.',
  battles: 'بازی‌ها',
  battlesActive: 'بازی‌های فعال',
  battlesActiveUsers: 'کاربران بازی‌های فعال',
  becomeFacilitator: 'تبدیل به تسهیل‌گر',
  becomeParticipant: 'تبدیل به شرکت‌کننده',
  becomeSpectator: 'تبدیل به تماشاگر',
  blocked: 'مسدود شده',
  blockers: 'موانع',
  blockersPlaceholder: 'من توسط... مسدود شده‌ام',
  brainstorm: 'بارش فکری',
  brainstormPhaseDescription: 'نظرات خود را در زیر اضافه کنید',
  brainstormPhaseFeedbackVisibility: 'قابلیت مشاهده بازخورد در مرحله بارش فکری',
  brainstormVisibilityLabelConcealed: 'بازخورد پنهان',
  brainstormVisibilityLabelHidden: 'بازخورد مخفی',
  brainstormVisibilityLabelVisible: 'بازخورد قابل مشاهده',
  cancel: 'لغو',
  cannotBeUndone: 'این عمل قابل بازگشت نیست.',
  checkIn: 'چک‌این',
  checkinCommentDeleteError: 'خطا در حذف نظر چک‌این',
  checkinCommentError: 'خطا در نظر دادن روی چک‌این',
  checkinError: 'خطا در چک‌این',
  checkinMeetYesterdayGoalsQuestion: 'آیا اهداف دیروز را برآورده کردید؟',
  checkins: 'چک‌این‌ها',
  colorLegend: 'راهنمای رنگ',
  colorLegendNotSpecified: 'راهنما مشخص نشده',
  comment: 'نظر',
  comments: 'نظرات',
  conciseVotingResults: 'نتایج مختصر رأی‌گیری',
  confirmDeleteRetro: 'آیا مطمئن هستید که می‌خواهید این رترو را حذف کنید؟',
  createAccount: 'ایجاد حساب',
  createAccountTagline: 'حساب کاربری ندارید؟',
  createAlertError: 'خطا در ایجاد هشدار',
  createAlertSuccess: 'هشدار با موفقیت ایجاد شد',
  createARetro: 'ایجاد یک رترو',
  createAStoryboard: 'ایجاد یک استوری‌بورد',
  createBattleError: 'خطا در ایجاد بازی',
  createOrgError: 'خطا در تلاش برای ایجاد سازمان',
  createRetro: 'ایجاد رترو',
  createRetroErrorMessage: 'خطا در ایجاد رترو',
  createStoryboard: 'ایجاد استوری‌بورد',
  createUserError: 'خطا در ایجاد کاربر',
  customizableBattleOptions: 'گزینه‌های قابل تنظیم بازی',
  dateCreated: 'تاریخ ایجاد',
  dateUpdated: 'تاریخ به‌روزرسانی',
  delete: 'حذف',
  deleteActionItemError: 'خطا در حذف آیتم اقدام',
  deleteActionItemSuccess: 'آیتم اقدام با موفقیت حذف شد',
  deleteAlertError: 'خطا در تلاش برای حذف هشدار',
  deleteAlertSuccess: 'هشدار با موفقیت حذف شد',
  deleteBattle: 'حذف بازی',
  deleteBattleConfirmText: 'آیا مطمئن هستید که می‌خواهید این بازی را حذف کنید؟',
  deleteBattleError: 'خطا در حذف بازی',
  deleteCheckinError: 'خطا در حذف چک‌این',
  deleteDepartment: 'حذف بخش',
  deleteDepartmentConfirmText: 'آیا مطمئن هستید که می‌خواهید این بخش را حذف کنید؟',
  deleteOrganization: 'حذف سازمان',
  deleteOrganizationConfirmText: 'آیا مطمئن هستید که می‌خواهید این سازمان را حذف کنید؟',
  deleteRetro: 'حذف رترو',
  deleteRetroErrorMessage: 'خطا در حذف رترو',
  deleteStoryboard: 'حذف استوری‌بورد',
  deleteStoryboardErrorMessage: 'خطا در حذف استوری‌بورد',
  deleteTeam: 'حذف تیم',
  deleteTeamConfirmText: 'آیا مطمئن هستید که می‌خواهید این تیم را حذف کنید؟',
  deleteUserError: 'خطا در حذف کاربر',
  demote: 'تنزل رتبه',
  demoteUserError: 'خطا در تنزل رتبه کاربر',
  department: 'بخش',
  departmentCreate: 'ایجاد بخش',
  departmentCreateError: 'خطا در تلاش برای ایجاد بخش',
  departmentDeleteError: 'خطا در تلاش برای حذف بخش',
  departmentDeleteSuccess: 'بخش با موفقیت حذف شد.',
  departmentGetError: 'خطا در دریافت بخش',
  departmentName: 'نام بخش',
  departmentNamePlaceholder: 'نام بخش را وارد کنید',
  departments: 'بخش‌ها',
  departmentSave: 'ذخیره بخش',
  departmentTeamsGetError: 'خطا در دریافت تیم‌های بخش',
  departmentUsersGetError: 'خطا در دریافت کاربران بخش',
  discuss: 'بحث',
  discussPlaceholder: 'من می‌خواهم در مورد... بحث کنم',
  done: 'انجام شده',
  duplicateRetroSession: 'جلسه رترو تکراری برای شناسه شما وجود دارد',
  duplicateStoryboardSession: 'جلسه استوری‌بورد تکراری برای شناسه شما وجود دارد',
  edit: 'ویرایش',
  editColorLegend: 'ویرایش راهنما',
  editRetro: 'ویرایش رترو',
  editStoryboard: 'ویرایش استوری‌بورد',
  email: 'ایمیل',
  enterPasscode: 'کد عبور را وارد کنید...',
  enterYourEmail: 'ایمیل خود را وارد کنید',
  execute: 'اجرا',
  export: 'صادرات',
  facilitator: 'تسهیل‌گر',
  facilitatorCode: 'کد تسهیل‌گر',
  facilitatorCodeOptional: 'کد تسهیل‌گر (اختیاری)',
  facilitatorCodePlaceholder: 'کد تسهیل‌گر اختیاری را وارد کنید',
  finalPoints: 'امتیازات نهایی',
  flag: 'پرچم',
  footerAuthoredBy: 'ساخته شده با ❤️ توسط {authorOpen}Steven Weathers{authorClose}',
  forgotPassword: 'رمز عبور خود را فراموش کردید؟',
  forgotPasswordSubtext:
    'نگران نباشید! فقط ایمیل خود را وارد کنید تا دستورالعمل‌های بازنشانی رمز عبور را برای شما ارسال کنیم.',
  returnToLogin: 'بازگشت به ورود',
  getAlertsError: 'خطا در دریافت هشدارها',
  getApikeysError: 'خطا در دریافت کلیدهای API',
  getBattleError: 'خطا در دریافت بازی',
  getBattlesError: 'خطا در دریافت بازی‌ها',
  getCheckinsError: 'خطا در دریافت چک‌این‌ها',
  getOrganizationsError: 'خطا در دریافت سازمان‌ها',
  getRetroErrorMessage: 'خطا در دریافت رترو',
  getRetrosErrorMessage: 'خطا در دریافت رتروها',
  getStoryboardErrorMessage: 'خطا در دریافت استوری‌بورد',
  getStoryboardsErrorMessage: 'خطا در دریافت استوری‌بوردها',
  getTeamsError: 'خطا در دریافت تیم‌ها',
  getUserError: 'خطا در دریافت کاربر',
  getUsersError: 'خطا در دریافت کاربران',
  goalsMet: 'اهداف برآورده شد',
  goalsNotMet: 'اهداف برآورده نشد',
  group: 'گروه',
  groupName: 'نام گروه',
  groupPhaseDescription: 'برای گروه‌بندی نظرات، آن‌ها را درگ اند دراپ کنید',
  hostedDesc: '{linkOpen}Thunderdome.dev{linkClose} یک سرویس رایگان میزبانی شده (SaaS) بدون تبلیغات است.',
  hostedOrSelfHosted: 'سرویس میزبانی شده یا خود میزبانی',
  importCsv: 'وارد کردن داستان‌ها از فایل CSV',
  importCsvFileBadFileTypeError: 'خطا در نوع فایل نامناسب',
  importCsvFileReadFileError: 'خطا در خواندن فایل',
  importJiraXML: 'وارد کردن داستان‌ها از Jira XML',
  importJiraXMLBadFileTypeError: 'خطا در نوع فایل نامناسب',
  importJiraXMLReadFileError: 'خطا در خواندن فایل',
  incorrectPassCode: 'کد عبور نادرست',
  inviteLinkCopyFailure: 'کپی لینک دعوت در کلیپ‌بورد ناموفق بود',
  inviteLinkCopySuccess: 'لینک دعوت در کلیپ‌بورد کپی شد',
  jiraXmlImport: 'وارد کردن Jira XML',
  joinCodeCopyFailure: 'کپی کد عبور در کلیپ‌بورد ناموفق بود',
  joinCodeCopySuccess: 'کد عبور در کلیپ‌بورد کپی شد',
  joinCodeLabelOptional: 'کد پیوستن (اختیاری)',
  joinCodePlaceholder: 'کد پیوستن را وارد کنید',
  joinRetro: 'پیوستن به رترو',
  joinStoryboard: 'پیوستن به استوری‌بورد',
  joinStoryboardError: 'خطا در پیوستن به استوری‌بورد، صفحه را بازخوانی و دوباره تلاش کنید.',
  landingCountries: 'کاربران در بیش از {count} کشور',
  landingFeatureOpenSourceText:
    '{repoOpen}مخزن گیت‌هاب{repoClose} را برای درخواست یا مشارکت در بهبودها، ترجمه‌های محلی و رفع باگ‌ها بررسی کنید یا {donateOpen}کمک مالی{donateClose} کنید.',
  landingFeatureOpenSourceTitle: 'متن‌باز',
  landingSalesPitch:
    'همکاری تیم راه دور با امتیازدهی داستان چابک، گذشت‌نگری اسپرینت، نقشه‌برداری داستان و چک‌این ناهمزمان تیم.',
  landingTitle: 'تاندردوم یک اپلیکیشن چابک پلنینگ پوکر است',
  lastActive: 'آخرین فعالیت',
  leaveRetro: 'ترک رترو',
  leaveStoryboard: 'ترک استوری‌بورد',
  legendRetroPlaceholder: 'راهنمای رنگ را وارد کنید',
  loadingRetro: 'بارگذاری رترو...',
  loadingStoryboard: 'بارگذاری استوری‌بورد...',
  login: 'ورود',
  loginForRetro: 'یا {loginOpen}وارد شوید{loginClose} تا به رترو بپیوندید',
  loginForStoryboard: 'یا {loginOpen}وارد شوید{loginClose} تا به استوری‌بورد بپیوندید',
  logout: 'خروج',
  logoutError: 'خطا در تلاش برای خروج کاربر',
  makeFacilitator: 'تبدیل به تسهیل‌گر',
  mfa2faLabel: 'احراز هویت دو مرحله‌ای/چند مرحله‌ای',
  mfa2faRemove: 'حذف 2FA/MFA',
  mfa2faRemoveFailure: 'حذف 2FA/MFA ناموفق بود',
  mfa2faRemoveSuccess: '2FA/MFA با موفقیت حذف شد',
  mfa2faRemoveText: 'آیا مطمئن هستید که می‌خواهید 2FA/MFA را حذف کنید؟',
  mfa2faSetup: 'تنظیم 2FA/MFA',
  mfaAuthError: 'خطا در اعتبارسنجی توکن احراز هویت',
  mfaConfirmToken: 'تأیید توکن',
  mfaGenerateFailed: 'شروع تنظیم 2FA/MFA ناموفق بود',
  mfaSecretKeyLabel: 'کلید مخفی',
  mfaSetupFailed: 'اعتبارسنجی توکن تنظیم 2FA/MFA ناموفق بود',
  mfaSetupIntro:
    'کد QR زیر را با یک اپلیکیشن احراز هویت (مانند Google Authenticator یا Authy) اسکن کنید و توکن تولید شده را وارد کنید.',
  mfaSetupSuccess: '2FA/MFA با موفقیت فعال شد',
  mfaTokenLabel: 'توکن احراز هویت',
  mfaTokenPlaceholder: 'توکن از اپلیکیشن احراز هویت را وارد کنید',
  myRetros: 'رتروهای من',
  myStoryboards: 'استوری‌بوردهای من',
  name: 'نام',
  needsImprovement: 'نیاز به بهبود',
  nextPhase: 'مرحله بعدی',
  noComments: 'نظری وجود ندارد...',
  oldBattleCleanError: 'خطا در پاک‌سازی بازی‌ها',
  oldGuestsCleanError: 'خطا در پاک‌سازی مهمان‌ها',
  oldRetrosCleanError: 'خطا در پاک‌سازی رتروها',
  oldStoryboardsCleanError: 'خطا در پاک‌سازی استوری‌بوردها',
  openSource: 'متن‌باز',
  optional: '(اختیاری)',
  optionalLeadercodePlaceholder: 'کد رهبر اختیاری برای تبدیل به رهبر',
  optionalPasscodePlaceholder: 'کد عبور اختیاری برای پیوستن',
  organization: 'سازمان',
  organizationCreate: 'ایجاد سازمان',
  organizationDeleteError: 'خطا در تلاش برای حذف سازمان',
  organizationDeleteSuccess: 'سازمان با موفقیت حذف شد.',
  organizationGetDepartmentsError: 'خطا در دریافت بخش‌های سازمان',
  organizationGetError: 'خطا در دریافت سازمان',
  organizationGetTeamsError: 'خطا در دریافت تیم‌های سازمان',
  organizationGetUsersError: 'خطا در دریافت کاربران سازمان',
  organizationName: 'نام سازمان',
  organizationNamePlaceholder: 'نام سازمان را وارد کنید',
  organizations: 'سازمان‌ها',
  organizationsAndTeams: 'سازمان‌ها و تیم‌ها',
  organizationSave: 'ذخیره سازمان',
  owner: 'مالک',
  participation: 'مشارکت',
  passCode: 'کد عبور',
  passCodeRequired: 'کد عبور برای پیوستن ضروری است',
  personas: 'شخصیت‌ها',
  planAcceptanceCriteria: 'معیارهای پذیرش',
  planAcceptanceCriteriaPlaceholder: 'معیارهای پذیرش را وارد کنید',
  planAdd: 'افزودن داستان‌ها',
  planDescription: 'توضیحات',
  planDescriptionPlaceholder: 'توضیحاتی را وارد کنید',
  planLink: 'لینک',
  planLinkInvalid: 'لینک یک URL مطلق معتبر نیست، مثلاً شامل پروتکل (HTTP/HTTPS)',
  planLinkPlaceholder: 'لینک داستان را وارد کنید',
  planName: 'نام داستان',
  planNamePlaceholder: 'نام داستان را وارد کنید',
  planPriority: 'اولویت',
  planPriorityBlocker: 'مانع',
  planPriorityHigh: 'بالا',
  planPriorityHighest: 'بالاترین',
  planPriorityLow: 'پایین',
  planPriorityLowest: 'پایین‌ترین',
  planPriorityMedium: 'متوسط',
  planPriorityPlaceholder: 'اولویت را انتخاب کنید',
  planReferenceId: 'شناسه مرجع',
  planReferenceIdPlaceholder: 'شناسه مرجع را وارد کنید',
  plans: 'داستان‌ها',
  planSkip: 'رد کردن داستان',
  planType: 'نوع داستان',
  planTypeBug: 'باگ',
  planTypeEpic: 'حماسه',
  planTypePlaceholder: 'انواع',
  planTypeSpike: 'اسپایک',
  planTypeStory: 'داستان',
  planTypeSubtask: 'زیروظیفه',
  planTypeTask: 'وظیفه',
  pointAverageRounding: 'گرد کردن میانگین امتیاز',
  pointed: 'امتیازدهی شده ({count})',
  points: 'امتیازات',
  pointValuesAllowed: 'مقادیر امتیاز مجاز',
  postComment: 'ارسال نظر',
  primeDirective: 'دستورالعمل اصلی',
  promote: 'ارتقا',
  promoteUserError: 'خطا در ارتقای کاربر',
  questions: 'سؤالات',
  register: 'ثبت‌نام',
  reloadingRetro: 'اوه، در حال بازخوانی رترو...',
  reloadingStoryboard: 'اوه، در حال بازخوانی استوری‌بورد...',
  remove: 'حذف',
  removeBattle: 'حذف بازی',
  removeBattleConfirmText: 'آیا مطمئن هستید که می‌خواهید این بازی را حذف کنید؟',
  removeRetro: 'حذف رترو',
  removeRetroConfirmText: 'آیا مطمئن هستید که می‌خواهید این رترو را حذف کنید؟',
  removeStoryboard: 'حذف استوری‌بورد',
  removeStoryboardConfirmText: 'آیا مطمئن هستید که می‌خواهید این استوری‌بورد را حذف کنید؟',
  removeUser: 'حذف کاربر',
  removeUserConfirmText: 'آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟',
  requestVerifyEmail: 'درخواست ایمیل تأیید',
  requestVerifyEmailFailure: 'خطا در تلاش برای ارسال ایمیل تأیید',
  requestVerifyEmailSuccess: 'ایمیل تأیید درخواست شد، صندوق ورودی خود را بررسی کنید',
  retro: 'رترو',
  retroActionCommentAddError: 'خطا در افزودن نظر اقدام رترو',
  retroActionCommentDeleteError: 'خطا در حذف نظر اقدام رترو',
  retroActionCommentEditError: 'خطا در ویرایش نظر اقدام رترو',
  retroActionItems: 'آیتم‌های اقدام رترو',
  retroAddError: 'خطا در تلاش برای افزودن رترو.',
  retroAddSuccess: 'رترو با موفقیت افزوده شد.',
  retroDeleted: 'رترو حذف شد',
  retroFeedbackConcealed: 'بازخورد پنهان',
  retroFeedbackHidden: 'بازخورد مخفی',
  retroGifAdd: 'افزودن GIF',
  retroGifClose: 'بستن جستجوی GIF',
  retroGifLoadMore: 'بارگذاری بیشتر',
  retroGifRateLimited: 'به سقف جستجوی GIF رسیدید، بعداً دوباره تلاش کنید',
  retroGifRemove: 'حذف GIF',
  retroGifSearchError: 'جستجوی GIF ناموفق بود، دوباره تلاش کنید',
  retroGifSearchNoResults: 'هیچ GIFی پیدا نشد',
  retroGifSearchPlaceholder: 'جستجوی GIF...',
  retroGifSubmit: 'ارسال',
  retroImprovePlaceholder: 'چه چیزی نیاز به بهبود دارد...',
  retroItems: 'آیتم‌های رترو',
  retroJoinError: 'خطا در پیوستن به رترو، صفحه را بازخوانی و دوباره تلاش کنید.',
  retroMaxVotesPerUserLabel: 'حداکثر رأی گروه (هر کاربر)',
  retroName: 'نام رترو',
  retroNamePlaceholder: 'نام رترو را وارد کنید',
  retroQuestionPlaceholder: 'می‌خواهم بپرسم...',
  retroRemoveError: 'خطا در تلاش برای حذف رترو.',
  retroRemoveSuccess: 'رترو با موفقیت حذف شد.',
  retros: 'رتروها',
  retroWorkedPlaceholder: 'چه چیزی خوب کار کرد...',
  role: 'نقش',
  rolePlaceholder: 'نقش کاربر را انتخاب کنید',
  save: 'ذخیره',
  search: 'جستجو',
  searchLengthError: 'مقدار جستجو باید حداقل ۳ کاراکتر باشد',
  selectTeam: 'تیمی را انتخاب کنید',
  selfHostedDesc: 'یا می‌توانید {linkOpen}آن را روی سرور خودتان اجرا کنید{linkClose}.',
  sessionDuplicate: 'جلسه بازی تکراری برای شناسه شما وجود دارد',
  showActiveBattles: 'نمایش بازی‌های فعال',
  showActiveRetros: 'نمایش رتروهای فعال',
  showActiveStoryboards: 'نمایش استوری‌بوردهای فعال',
  showBlockedCheckins: 'فقط چک‌این‌هایی که نیاز به بحث دارند نشان بده',
  showCompletedActionItems: 'نمایش آیتم‌های اقدام تکمیل شده',
  showVoters: 'نمایش رأی‌دهندگان',
  skipped: 'رد شده',
  spectator: 'تماشاگر',
  storyboard: 'استوری‌بورد',
  storyboardAddColumn: 'افزودن ستون',
  storyboardAddError: 'خطا در تلاش برای افزودن استوری‌بورد.',
  storyboardAddGoal: 'افزودن هدف',
  storyboardAddStoryToColumn: 'افزودن داستان به ستون',
  storyboardAddSuccess: 'استوری‌بورد با موفقیت افزوده شد.',
  storyboardColumns: 'ستون‌های استوری‌بورد',
  storyboardDeleted: 'استوری‌بورد حذف شد',
  storyboardEditColumn: 'ویرایش ستون',
  storyboardGoalName: 'نام هدف',
  storyboardGoalNamePlaceholder: 'نام هدف را وارد کنید',
  storyboardGoals: 'اهداف استوری‌بورد',
  storyboardPersonas: 'شخصیت‌های استوری‌بورد',
  storyboardRemoveError: 'خطا در تلاش برای حذف استوری‌بورد.',
  storyboardRemoveSuccess: 'استوری‌بورد با موفقیت حذف شد.',
  storyboards: 'استوری‌بوردها',
  storyboardStories: 'داستان‌های استوری‌بورد',
  columnPersonasTitle: 'شخصیت‌های ستون',
  columnPersonasEmpty: 'هیچ شخصیتی در این ستون اضافه نشده است',
  availablePersonas: 'شخصیت‌های موجود',
  availablePersonasEmpty: 'هیچ شخصیتی موجود نیست',
  allPersonasAdded: 'تمام شخصیت‌ها در این ستون اضافه شده‌اند',
  team: 'تیم',
  teamCheckins: 'چک‌این‌های تیم',
  teamCreate: 'ایجاد تیم',
  teamCreateError: 'خطا در تلاش برای ایجاد تیم.',
  teamCreateSuccess: 'تیم با موفقیت ایجاد شد.',
  teamDeleteError: 'خطا در تلاش برای حذف تیم',
  teamDeleteSuccess: 'تیم با موفقیت حذف شد.',
  teamGetBattlesError: 'خطا در دریافت بازی‌های تیم',
  teamGetError: 'خطا در دریافت تیم',
  teamGetRetroActionsError: 'خطا در دریافت اقدامات رترو',
  teamGetRetrosError: 'خطا در دریافت رتروهای تیم',
  teamGetStoryboardsError: 'خطا در دریافت استوری‌بوردهای تیم',
  teamGetUsersError: 'خطا در دریافت کاربران تیم',
  teamName: 'نام تیم',
  teamNamePlaceholder: 'نام تیم را وارد کنید',
  teams: 'تیم‌ها',
  teamSave: 'ذخیره تیم',
  teamUserRequiredToCheckin: 'کاربر باید در تیم باشد تا چک‌این کند',
  teamUserRequiredToComment: 'کاربر باید در تیم باشد تا نظر بدهد',
  today: 'امروز',
  todayPlaceholder: 'امروز من...',
  totalPoints: 'مجموع',
  totalVotes: 'مجموع آرا',
  type: 'نوع',
  unknownWarrior: 'بازیکن ناشناس',
  unpointed: 'بدون امتیاز ({count})',
  updateActionItemError: 'خطا در به‌روزرسانی آیتم اقدام',
  updateActionItemSuccess: 'آیتم اقدام با موفقیت به‌روزرسانی شد',
  updateAlertError: 'خطا در به‌روزرسانی هشدار',
  updateAlertSuccess: 'هشدار با موفقیت به‌روزرسانی شد',
  updateCheckinError: 'خطا در به‌روزرسانی چک‌این',
  updateComment: 'به‌روزرسانی نظر',
  userAdd: 'افزودن کاربر',
  userAddError: 'خطا در تلاش برای افزودن کاربر.',
  userAddSuccess: 'کاربر با موفقیت افزوده شد.',
  userEmail: 'ایمیل کاربر',
  userEmailPlaceholder: 'ایمیل کاربر را وارد کنید',
  userName: 'نام کاربر',
  userRemoveError: 'خطا در تلاش برای حذف کاربر.',
  userRemoveSuccess: 'کاربر با موفقیت حذف شد.',
  users: 'کاربران',
  verifyAccount: 'تأیید حساب',
  verifyAccountFailedError: 'خطایی در تأیید حساب شما رخ داد، شاید این لینک منقضی شده یا قبلاً استفاده شده است.',
  verifyAccountFailedTitle: 'تأیید ناموفق',
  verifyAccountLoading: 'در حال تأیید حساب...',
  verifyAccountVerifiedThanks: 'از تأیید ایمیل شما متشکریم.',
  verifyAccountVerifiedTitle: 'حساب تأیید شد',
  view: 'مشاهده',
  vote: 'رأی',
  voteCount: 'تعداد آرا',
  votePhaseDescription: 'به گروه‌هایی که می‌خواهید بیشتر در موردشان بحث کنید رأی دهید',
  voteResultsAverage: 'میانگین',
  voteResultsHighest: 'بالاترین',
  votingFinish: 'پایان رأی‌گیری',
  votingLocked: 'رأی‌گیری قفل شده',
  votingRestart: 'شروع مجدد رأی‌گیری',
  warriorCreate: 'ایجاد کاربر',
  warriorInvite: 'دعوت بازیکن',
  warriorNudge: 'یادآوری',
  works: 'کارها',
  writeCommentPlaceholder: 'نظری بنویسید...',
  yesterday: 'دیروز',
  yesterdayPlaceholder: 'دیروز من...',
  yourRetros: 'رتروهای شما',
  yourStoryboards: 'استوری‌بوردهای شما',
  addPlan: 'افزودن داستان',
  battleNamePlaceholder: 'نام بازی را وارد کنید',
  autoFinishVotingLabel: 'خودکار پایان دادن رأی‌گیری وقتی همه بازیکنان رأی دادند',
  averageRoundingOptions: {
    ceil: 'سقف',
    floor: 'کف',
    round: 'گرد',
  },
  apiKeyCreateButton: 'ایجاد کلید API',
  apiKeyPrefix: 'پیشوند کلید',
  lastUpdated: 'آخرین به‌روزرسانی',
  apiKeysErrorRetrieving: 'دریافت کلیدهای API ناموفق بود',
  apiKeyDeleteSuccess: 'کلید API حذف شد',
  apiKeyDeleteFailed: 'حذف کلید API ناموفق بود',
  apiKeyUpdateSuccess: 'کلید API به‌روزرسانی شد',
  apiKeyUpdateFailed: 'به‌روزرسانی کلید API ناموفق بود',
  deactivate: 'غیرفعال‌سازی',
  profileErrorRetrieving: 'خطا در دریافت پروفایل شما',
  profileErrorUpdating: 'خطا در به‌روزرسانی پروفایل شما',
  profileUpdateSuccess: 'پروفایل به‌روزرسانی شد',
  passwordUpdated: 'رمز عبور به‌روزرسانی شد.',
  passwordUpdateError: 'خطا در تلاش برای به‌روزرسانی رمز عبور',
  profileDeleteError: 'خطا در تلاش برای حذف حساب شما.',
  profileTitle: 'پروفایل شما',
  profile: 'پروفایل',
  updatePassword: 'به‌روزرسانی رمز عبور',
  deleteAccount: 'حذف حساب',
  deleteAccountWarningStatement: 'آیا مطمئن هستید که می‌خواهید حساب خود را حذف کنید؟',
  deleteConfirmButton: 'تأیید حذف',
  apiKeyNameInvalid: 'لطفاً نام کلید را وارد کنید',
  apiKeyCreateSuccess: 'کلید API جدید {keyName} ایجاد شد و {onlyNowOpen}فقط الان نمایش داده می‌شود{onlyNowClose}',
  apiKeyStoreWarning:
    'لطفاً آن را در جایی امن ذخیره کنید زیرا به محض اینکه از این صفحه خارج شوید، نمی‌توانیم این توکن تولید شده را بازیابی یا بازیابی کنیم.',
  apiKeyLimitReached: 'شما حداکثر تعداد کلیدهای API مجاز را دارید.',
  apiKeyUnverifiedUser: 'فقط کاربران ثبت‌نام شده تأیید شده می‌توانند کلیدهای API ایجاد کنند.',
  apiKeyCreateFailed: 'ایجاد کلید API ناموفق بود',
  apiKeyName: 'نام کلید',
  apiKeyNamePlaceholder: 'نام کلید را وارد کنید',
  create: 'ایجاد',
  close: 'بستن',
  country: 'کشور',
  company: 'شرکت',
  verified: 'تأیید شده',
  registeredUsers: 'کاربران ثبت‌نام شده',
  myBattles: 'بازی‌های من',
  createBattle: 'ایجاد بازی',
  countPlansPointed: '{totalPointed} از {totalPlans} داستان امتیازدهی شده',
  myBattlesError: 'خطا در یافتن بازی‌های شما',
  warriorJoined: '{name} به بازی پیوست',
  warriorRetreated: '{name} بازی را ترک کرد',
  planSkipped: 'داستان رد شد',
  warriorVoted: '{name} رأی داد',
  warriorRetractedVote: '{name} رأی خود را پس گرفت',
  battleDeleted: 'بازی حذف شد',
  warriorNudgeMessage: 'پست... {name}، منتظر رأی شما هستیم.',
  battle: 'بازی',
  warriors: 'بازیکنان',
  battleSocketReconnecting: 'اوه در حال بازخوانی بازی...',
  battleSocketError: 'خطا در پیوستن به بازی، صفحه را بازخوانی و دوباره تلاش کنید.',
  battleLoading: 'بارگذاری بازی...',
  votingNotStarted: 'رأی‌گیری شروع نشده',
  password: 'رمز عبور',
  passwordPlaceholder: 'رمز عبور را وارد کنید',
  yourPasswordPlaceholder: 'رمز عبور خود را وارد کنید',
  confirmPassword: 'تأیید رمز عبور',
  confirmPasswordPlaceholder: 'رمز عبور خود را تأیید کنید',
  update: 'به‌روزرسانی',
  reset: 'بازنشانی',
  passwordResetError: 'خطا در تلاش برای بازنشانی رمز عبور',
  resetPassword: 'بازنشانی رمز عبور',
  registerAsGuest: 'ثبت‌نام به عنوان مهمان',
  registrationDisabled: 'ثبت‌نام غیرفعال است.',
  userNamePlaceholder: 'نام خود را وارد کنید',
  guestRegisterError: 'خطا در تلاش برای ثبت‌نام به عنوان مهمان',
  registerError: 'خطا در تلاش برای ثبت‌نام حساب',
  enlistToBattle: 'نام‌نویسی برای نبرد',
  loginForBattle: 'یا {loginOpen}وارد شوید{loginClose} تا به بازی بپیوندید',
  yourNamePlaceholder: 'نام خود را وارد کنید',
  createAccountFormTitle: 'ایجاد حساب {optionalOpen}(اختیاری){optionalClose}',
  sendResetPasswordSuccess: 'دستورالعمل‌های بازنشانی رمز عبور به {email} ارسال شد',
  sendResetPasswordError: 'خطا در تلاش برای ارسال بازنشانی رمز عبور',
  chooseCountryPlaceholder: 'کشور خود را انتخاب کنید (اختیاری)',
  locale: 'زبان',
  companyPlaceholder: 'شرکت خود را وارد کنید (اختیاری)',
  jobTitle: 'عنوان شغلی',
  jobTitlePlaceholder: 'عنوان شغلی خود را وارد کنید (اختیاری)',
  enableBattleNotifications: 'فعال‌سازی اعلان‌های بازی',
  avatar: 'آواتار',
  updateProfile: 'به‌روزرسانی پروفایل',
  guestUsers: 'کاربران مهمان',
  maintenance: 'نگهداری',
  cleanGuests: 'پاک‌سازی مهمان‌های قدیمی‌تر از {daysOld} روز',
  cleanBattles: 'پاک‌سازی بازی‌های قدیمی‌تر از {daysOld} روز',
  chooseLocalePlaceholder: 'زبان ترجیحی خود را انتخاب کنید (اختیاری)',
  importPlans: 'وارد کردن داستان‌ها',
  selectFile: 'انتخاب فایل...',
  theme: 'قالب',
  assignees: 'مسئولان',
  assigneeSelectPlaceholder: 'مسئولی را برای افزودن انتخاب کنید',
  assigneeAdd: 'افزودن مسئول',
  allStoryWithCount: 'همه ({count})',
  userUpdate: 'به‌روزرسانی کاربر',
  userUpdateSuccess: 'کاربر با موفقیت به‌روزرسانی شد.',
  userUpdateError: 'خطا در به‌روزرسانی کاربر.',
  invites: 'دعوت‌نامه‌ها',
  userInvites: 'دعوت‌نامه‌های کاربر',
  userInviteSent: 'دعوت‌نامه کاربر ارسال شد',
  userInviteConfirmDelete: 'آیا مطمئن هستید که می‌خواهید این دعوت‌نامه کاربر را حذف کنید؟',
  userInviteDelete: 'حذف دعوت‌نامه',
  acceptInvite: 'پذیرش دعوت‌نامه',
  rejectInvite: 'رد دعوت‌نامه',
  rejectingInvite: 'در حال رد کردن...',
  inviteRejected: 'دعوت‌نامه رد شد',
  inviteRejectError: 'خطا در رد کردن دعوت‌نامه',
  getUserInvitesError: 'خطا در دریافت دعوت‌نامه‌های کاربر',
  expireDate: 'تاریخ انقضا',
  addUserWillInviteNotFoundFieldNote:
    'اگر کاربر ثبت‌نام نکرده باشد، دعوت‌نامه‌ای برای ثبت‌نام و پیوستن به {pageType} ارسال خواهد شد.',
  inviteUserFieldNote: 'دعوت‌نامه‌ای برای پیوستن به {pageType} ارسال خواهد شد.',
  requiresOrganizationMember: 'کاربر باید از قبل در سازمان باشد.',
  teamUpdateSuccess: 'تیم با موفقیت به‌روزرسانی شد',
  teamUpdateError: 'خطا در به‌روزرسانی تیم',
  orgUpdateSuccess: 'سازمان با موفقیت به‌روزرسانی شد',
  orgUpdateError: 'خطا در به‌روزرسانی سازمان',
  deptUpdateSuccess: 'بخش با موفقیت به‌روزرسانی شد',
  deptUpdateError: 'خطا در به‌روزرسانی بخش',
  hideVoterIdentity: 'مخفی کردن هویت رأی‌دهنده',
  storyboardName: 'نام استوری‌بورد',
  storyboardNamePlaceholder: 'نام استوری‌بورد را وارد کنید',
  retroPhaseTimeLimitMinLabel: 'محدودیت زمانی مرحله بارش فکری بر حسب دقیقه',
  phaseAutoAdvanceLabel: 'پیشروی خودکار مراحل',
  removeOnlyFacilitatorError: 'نمی‌توان تنها تسهیل‌گر را حذف کرد',
  noGamesFound: 'هیچ بازی یافت نشد، سعی کنید یکی ایجاد کنید.',
  noRetrosFound: 'هیچ رترو یافت نشد، سعی کنید یکی ایجاد کنید.',
  noStoryboardsFound: 'هیچ استوری‌بورد یافت نشد، سعی کنید یکی ایجاد کنید.',
  retroDescription:
    'گذشت‌نگری اسپرینت یک بررسی است که پس از اسپرینت انجام می‌شود و نقش کلیدی در روش‌شناسی چابک ایفا می‌کند. هدف گذشت‌نگری اسپرینت تعیین آنچه خوب پیش رفت و جایی که مشکل داشتید و شناسایی نواحی که می‌توانید بهبود دهید است.',
  pokerDescription:
    'اسکرام پوکر، که به عنوان "پلنینگ پوکر" و "پوینتینگ پوکر" نیز شناخته می‌شود، تکنیکی بازی‌وار شده است که تیم‌های توسعه برای حدس زدن تلاش وظایف مدیریت پروژه استفاده می‌کنند. این تخمین‌ها بر اساس ورودی و اجماع کل گروه است و آن‌ها را جذاب‌تر و دقیق‌تر از روش‌های دیگر می‌کند.',
  storyboardDescription:
    'نقشه‌برداری داستان کاربر (استوری‌بورد) تجسمی از سفری است که مشتری با محصول، از ابتدا تا انتها، طی می‌کند. شامل همه وظایفی است که آن‌ها معمولاً به عنوان بخشی از آن سفر تکمیل می‌کنند.',
  estimationScaleNamePlaceholder: 'نام مقیاس را وارد کنید',
  description: 'توضیحات',
  estimationScaleDescriptionPlaceholder: 'توضیحات مقیاس را وارد کنید',
  scaleType: 'نوع مقیاس',
  estimationScaleTypePlaceholder: 'نوع مقیاس را انتخاب کنید',
  scaleValues: 'مقادیر مقیاس',
  estimationScaleValuesPlaceholder: 'مقادیر جدا شده با کاما را وارد کنید',
  estimationScaleValuesHelp: 'مقادیر را با کاما جدا کنید (مثال: 1, 2, 3, 5, 8)',
  estimationScaleIsPublic: 'این مقیاس را عمومی کنید',
  estimationScaleDefault: 'به عنوان مقیاس پیش‌فرض تنظیم کنید',
  estimationScaleSave: 'ذخیره مقیاس',
  estimationScales: 'مقیاس‌های تخمین',
  estimationScaleCreate: 'ایجاد مقیاس تخمین',
  estimationScaleCreateSuccess: 'مقیاس تخمین با موفقیت ایجاد شد',
  estimationScaleCreateError: 'خطا در ایجاد مقیاس تخمین',
  estimationScaleUpdateSuccess: 'مقیاس تخمین با موفقیت به‌روزرسانی شد',
  estimationScaleUpdateError: 'خطا در به‌روزرسانی مقیاس تخمین',
  estimationScaleRemoveSuccess: 'مقیاس تخمین با موفقیت حذف شد',
  estimationScaleRemoveError: 'خطا در حذف مقیاس تخمین',
  removeEstimationScaleConfirmText: 'آیا مطمئن هستید که می‌خواهید این مقیاس تخمین را حذف کنید؟',
  removeEstimationScale: 'حذف مقیاس تخمین',
  yes: 'بله',
  no: 'خیر',
  isPublic: 'عمومی',
  default: 'پیش‌فرض',
  publicEstimationScales: 'مقیاس‌های تخمین عمومی',
  organizationEstimationScales: 'مقیاس‌های تخمین سازمان',
  teamEstimationScales: 'مقیاس‌های تخمین تیم',
  allowCumulativeVotingLabel: 'اجازه رأی‌گیری تجمعی (بیش از ۱ رأی به هر گروه آیتم)',
  activeSubscriptions: 'اشتراک‌های فعال',
  retroTemplates: 'قالب‌های رترو',
  publicRetroTemplates: 'قالب‌های رترو عمومی',
  organizationRetroTemplates: 'قالب‌های رترو سازمان',
  teamRetroTemplates: 'قالب‌های رترو تیم',
  retroTemplateNamePlaceholder: 'نام قالب را وارد کنید',
  retroTemplateDescriptionPlaceholder: 'توضیحات قالب را وارد کنید',
  format: 'فرمت',
  retroTemplateIsPublic: 'این قالب را عمومی کنید',
  retroTemplateSave: 'ذخیره قالب',
  retroTemplateCreate: 'ایجاد قالب گذشت‌نگری',
  retroTemplateCreateSuccess: 'قالب گذشت‌نگری با موفقیت ایجاد شد',
  retroTemplateCreateError: 'خطا در ایجاد قالب گذشت‌نگری',
  retroTemplateUpdateSuccess: 'قالب گذشت‌نگری با موفقیت به‌روزرسانی شد',
  retroTemplateUpdateError: 'خطا در به‌روزرسانی قالب گذشت‌نگری',
  retroTemplateRemoveSuccess: 'قالب گذشت‌نگری با موفقیت حذف شد',
  retroTemplateRemoveError: 'خطا در حذف قالب گذشت‌نگری',
  removeRetroTemplateConfirmText: 'آیا مطمئن هستید که می‌خواهید این قالب گذشت‌نگری را حذف کنید؟',
  removeRetroTemplate: 'حذف قالب گذشت‌نگری',
  retroTemplateDefault: 'به عنوان قالب پیش‌فرض تنظیم کنید',
  jiradatacenterLabel: 'مرکز داده جیرا',
  loginWithSSO: 'ورود با {provider}',
  requestEmailChangeSuccess: 'درخواست تغییر ایمیل ارسال شد، صندوق ورودی خود را برای دستورالعمل‌ها بررسی کنید',
  requestEmailChangeError: 'خطا در تلاش برای تغییر ایمیل',
  changeEmail: 'تغییر ایمیل',
  errorChangingEmail: 'خطا در تلاش برای تغییر ایمیل، شاید این پیوند منقضی شده یا قبلاً استفاده شده است.',
  emailChanged: 'ایمیل با موفقیت تغییر یافت',
  newEmailToLogin: 'از این پس، لطفاً از ایمیل جدید خود برای ورود استفاده کنید.',
  newEmail: 'ایمیل جدید',
  enterYourNewEmail: 'ایمیل جدید خود را وارد کنید',
  retroSettings: 'تنظیمات رترو',
  enterFacilitatorCode: 'کد تسهیل‌گر را وارد کنید',
  // Modal ariaLabels
  modalCreateAlert: 'ایجاد هشدار',
  modalUpdateEstimationScale: 'به‌روزرسانی مقیاس تخمین',
  modalDeleteConfirmation: 'تأیید حذف',
  modalCreateEstimationScale: 'ایجاد مقیاس تخمین',
  modalTeamCheckin: 'بررسی تیم',
  modalAddPokerStory: 'افزودن داستان پوکر',
  modalCreateUser: 'ایجاد کاربر',
  modalCreateApiKey: 'ایجاد کلید API',
  modalImportPokerStories: 'وارد کردن داستان‌های پوکر',
  modalSetupMultifactorAuth: 'تنظیم احراز هویت چند عاملی',
  modalEditPokerGame: 'ویرایش بازی پوکر',
  modalCreateJiraInstance: 'ایجاد نمونه Jira',
  modalUpdatePokerSettings: 'به‌روزرسانی تنظیمات پوکر',
  modalAddStoryboardGoal: 'افزودن هدف استوری‌بورد',
  modalViewPokerStory: 'مشاهده داستان پوکر',
  modalStoryboardColumnSettings: 'تنظیمات ستون استوری‌بورد',
  modalEditStoryboard: 'ویرایش استوری‌بورد',
  modalStoryboardColorLegend: 'راهنمای رنگ استوری‌بورد',
  modalStoryboardPersonas: 'شخصیت‌های استوری‌بورد',
  modalRetroActionComments: 'نظرات اقدام رترو',
  modalStoryboardStory: 'داستان استوری‌بورد',
  modalTeamAddUser: 'افزودن کاربر به تیم',
  modalCreateDepartment: 'ایجاد بخش',
  modalCreateTeam: 'ایجاد تیم',
  modalCreateOrganization: 'ایجاد سازمان',
  modalCreateRetroTemplate: 'ایجاد قالب رترو',
  modalViewRetroTemplateFormat: 'مشاهده فرمت قالب رترو',
  modalUpdateRetroTemplate: 'به‌روزرسانی قالب رترو',
  modalAssociateTeamToSubscription: 'ارتباط تیم با اشتراک',
  modalAssociateOrganizationToSubscription: 'ارتباط سازمان با اشتراک',
  modalTeamUpdateUser: 'به‌روزرسانی کاربر تیم',
  modalSubscriptionForm: 'فرم اشتراک',
  modalEditRetro: 'ویرایش رترو',
  modalEditRetroActionItem: 'ویرایش آیتم اقدام رترو',
  modalRetroItemComments: 'نظرات آیتم رترو',
  modalUpdateRetroSettings: 'به‌روزرسانی تنظیمات رترو',
  githubRepository: 'مخزن گیت‌هاب',
  projects: 'پروژه‌ها',
  projectCreate: 'ایجاد پروژه',
  projectKey: 'کلید پروژه',
  scope: 'حوزه',
  createdAt: 'ایجاد شده در',
  projectRemoveSuccess: 'پروژه با موفقیت حذف شد',
  projectRemoveError: 'خطا در حذف پروژه',
  removeProjectConfirmText: 'آیا مطمئن هستید که می‌خواهید این پروژه را حذف کنید؟ این عمل قابل بازگشت نیست.',
  removeProject: 'حذف پروژه',
  modalCreateProject: 'ایجاد پروژه',
  modalUpdateProject: 'به‌روزرسانی پروژه',
  projectKeyPlaceholder: 'کلید پروژه را وارد کنید (مثال: PROJ)',
  projectNamePlaceholder: 'نام پروژه را وارد کنید',
  projectDescriptionPlaceholder: 'توضیحات پروژه را وارد کنید (اختیاری)',
  projectKeyValidationError: 'کلید پروژه باید ۲-۱۰ کاراکتر حروف و اعداد باشد',
  projectKeyHelp: '۲-۱۰ کاراکتر، فقط حروف و اعداد',
  projectScope: 'محدوده پروژه',
  projectUpdate: 'به‌روزرسانی پروژه',
  projectCreateSuccess: 'پروژه با موفقیت ایجاد شد',
  projectUpdateSuccess: 'پروژه با موفقیت به‌روزرسانی شد',
  projectCreateError: 'ایجاد پروژه با شکست مواجه شد',
  projectUpdateError: 'به‌روزرسانی پروژه با شکست مواجه شد',
  project: 'پروژه',
  gameSettings: 'تنظیمات بازی',
  endGame: 'پایان بازی',
  endGameReason: 'دلیل پایان بازی',
  endGameReasonPlaceholder: 'یک دلیل انتخاب کنید',
  welcomeBack: 'خوش آمدید،',
  dashboardSubtitle: 'بیایید جلسه همکاری تیمی بعدی شما را بهترین کنیم.',
  filterByTeam: 'فیلتر بر اساس تیم:',
  allTeams: 'همه تیم‌ها',
  showContentForAllTeams: 'نمایش محتوا از همه تیم‌ها',
  clearFilter: 'پاک کردن فیلتر',
  teamPage: 'صفحه تیم',
  dashboardTeamsRequired: 'برای مشاهده جلسات برنامه‌ریزی پوکر، رتروسپکتیوها و استوری‌بوردها، یک تیم را انتخاب کنید.',
  planningPokerSessions: 'جلسات برنامه‌ریزی پوکر',
  viewAllPokerSessions: 'مشاهده همه جلسات برنامه‌ریزی پوکر',
  totalPokerSessions: '{total} جلسه در مجموع',
  noSessionsFoundForTeam: 'هیچ جلسه‌ای برای {teamName} یافت نشد',
  noSessionsFound: 'هیچ جلسه‌ای یافت نشد',
  trySelectingDifferentTeamForPoker: 'تیم دیگری را انتخاب کنید یا یک بازی جدید بسازید',
  startFirstPlanningPokerSession: 'اولین جلسه برنامه‌ریزی پوکر خود را شروع کنید',
  sprintRetrospectives: 'رتروسپکتیوهای اسپرینت',
  viewAllRetros: 'مشاهده همه رتروسپکتیوها',
  totalRetros: '{total} رتروسپکتیو در مجموع',
  noRetrosFoundForTeam: 'هیچ رتروسپکتیوی برای {teamName} یافت نشد',
  startFirstSprintRetrospective: 'اولین رتروسپکتیو اسپرینت خود را شروع کنید',
  trySelectingDifferentTeamForRetros: 'تیم دیگری را انتخاب کنید یا یک رتروسپکتیو جدید بسازید',
  viewAllStoryboards: 'مشاهده همه استوری‌بوردها',
  totalStoryboards: '{total} استوری‌بورد در مجموع',
  noStoryboardsFoundForTeam: 'هیچ استوری‌بوردی برای {teamName} یافت نشد',
  startFirstStoryboard: 'اولین استوری‌بورد خود را شروع کنید',
  agileStoryMapping: 'نقشه‌برداری داستان چابک',
  trySelectingDifferentTeamForStoryboards: 'تیم دیگری را انتخاب کنید یا یک استوری‌بورد جدید بسازید',
  supportTickets: 'تیکت‌های پشتیبانی',
  supportTicketDeleteConfirmation:
    'آیا مطمئن هستید که می‌خواهید این تیکت پشتیبانی را حذف کنید؟ این عمل قابل بازگشت نیست.',
  supportTicketDelete: 'حذف تیکت',
  updateSupportTicketSuccess: 'تیکت پشتیبانی با موفقیت به‌روزرسانی شد',
  updateSupportTicketError: 'خطا در به‌روزرسانی تیکت پشتیبانی',
  getSupportTicketsError: 'خطا در دریافت تیکت‌های پشتیبانی',
  deleteSupportTicketSuccess: 'تیکت پشتیبانی با موفقیت حذف شد',
  deleteSupportTicketError: 'خطا در حذف تیکت پشتیبانی',
  clear: 'پاک کردن',
};

export default fa;
